import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import { FaEye, FaLink } from 'react-icons/fa';
import { MdPending, MdCheckCircle, MdDelete } from 'react-icons/md';
import { baseUrl } from "../../shared/baseUrl";
import Modal  from 'react-modal';
import { VscChromeClose } from 'react-icons/vsc';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ReactPaginate from "react-paginate";
import TableHandler from '../../components/admin/TableHandler';
import Swal from 'sweetalert2';
import ImagePreviewModal from '../../components/ImagePreviewModal';

const AllProperties = () => {
  const navigate = useNavigate()

  Modal.setAppElement('#root')

  const [previewModal, setPreviewModal] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(1)

  const [modalOpen, setModalOpen] = useState(false)

  // --- Toggle SideBar --- //
  const [toggleNav, setToggleNav] = useState(false)

  const [category, setCategory] = useState("all")
  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState([])
  const [propDetails, setPropDetails] = useState({})
  const [propertyId, setPropertyId] = useState("")

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0)
  const itemsPerPage = 10
  const pagesVisited = pageNumber * itemsPerPage
  const pageCount = Math.ceil(data?.length / itemsPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)
  const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
  // --- Pagination --- //

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userInfo?.token}`
    }
  }

  useEffect(() => {
    document.title = "Island Luxury - Properties"
		if(!userInfo) {
			navigate('/')
		} 
    else {
      const getProperties = async () => {
        try {
          setLoading(true)
          const res = await axios.get(baseUrl + "/api/v1/properties", config)
          setLoading(false)
          setData(res.data.properties)
          setFilterData(res.data.properties)
        }
        catch(err){
          setLoading(false)
          setError(err.response && err.response.data.message ? err.response.data.message : err.message)
        }
      }
      getProperties()
    }
	}, [userInfo, navigate, modalOpen])

  useEffect(() => {
    setPropDetails(data.filter(item => item._id === propertyId))
	}, [propertyId])

  // --- Category switching
  useEffect(() => {
    if(category === "all") {
      setData(filterData)
    } else {
      const results = filterData?.filter(item => (item.category.includes(category)))
      setData(results)
    }
  }, [category])

  // --- Handle Approve Property --- //
  const handleApproveProperty = () => {
    const approveProperty = async () => {
      const res = await axios.put(baseUrl + `/api/v1/properties/approved/${propertyId}`, { approved: true }, config)
      Swal.fire({
        icon: 'success',
        title: 'Approved',
        text: "Property have been approved!"
      })
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
      return res
    }
    approveProperty()
  }

  // --- Handle Delete Property --- //
  const handleDeleteProperty = (item) => {
    const deleteProperty = async () => {
      try {
        await axios.delete(baseUrl + `/api/v1/properties/${item._id}`, config)
        Swal.fire({
          icon: 'success',
          title: 'Delete',
          text: "You deleted a Property",
        })
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}, please try again!`,
        })
      }
    }
    deleteProperty(item._id)
  }

  // --- Format Currency --- //
  const formatToCurrency = Intl.NumberFormat('en-US')

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="my-listing">
        <section className="page-title">
          <h3><Link to="/dashboard">Dashboard</Link> | All Properties</h3>
        </section>
        <section className="my-listing_cont">
          <div className="category-tab">
            <button className= "all" onClick={() => setCategory("all")}>All</button>
            <button className="rent" onClick={() => setCategory("Rent")}>Rent</button>
            <button className="sale" onClick={() => setCategory("Sale")}>Sale</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Price</th>
                <th>Location</th>
                <th>Category</th>
                <th>Bed(s)</th>
                <th>Bath(s)</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading && displayData.map((item, index) => 
                <tr key={index}>
                  <td>{item.title}</td>
                  <td>{item.propertyType}</td>
                  <td>{formatToCurrency.format(item.price)}</td>
                  <td>{item.state}</td>
                  <td>
                    {item.category === "Rent" ?
                      <span className="table-rent">Rent</span>
                    :
                      <span className="table-sale">Sale</span>
                    }
                  </td>
                  <td>{item.bedrooms}</td>
                  <td>{item.bath}</td>
                  <td className="table-status">
                    {item.approved ? 
                      <div title="Approved">
                        <MdCheckCircle size={25} />
                      </div>
                    :
                      <div title="Pending">
                        <MdPending size={25} />
                      </div>
                    }
                  </td>
                  <td className="table-action">
                    <button className="eye" title="View Property" onClick={() => {setModalOpen(true); setPropertyId(item._id)}}>
                      View <FaEye size={20} />
                    </button>
                    {item.approved && 
                      <Link to={`/property-details/${item._id}`} className="link" title="Product Web Page" target="_blank">
                        Link <FaLink size={20} />
                      </Link>
                    }
                    <button className="del" onClick={() => handleDeleteProperty(item)} title="Delete Property">
                      Del <MdDelete size={20} />
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <TableHandler data={data} loading={loading} error={error} />

          {data?.length > itemsPerPage &&
            <div className="pagination-tab">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"} />
            </div>
					}

          <Modal isOpen={modalOpen} closeTimeoutMS={200}> 
            <div className="modal-header">
              <h2>Property Details</h2>
              <button onClick={() => setModalOpen(false)}>
                <VscChromeClose size={25} />
              </button>
            </div>
            <div className="modal-body view_approve-prop">
              {!propDetails[0]?.approved &&
                <div className="approval-btn">
                  <button 
                    type="button" 
                    disabled={propDetails[0]?.images?.length === 0 && true} 
                    onClick={handleApproveProperty}>
                      Approve <MdCheckCircle size={15} />
                  </button>
                  {propDetails[0]?.images?.length === 0 && <small>Can't approve. No images yet!</small>}
                </div>
              }
              <div className="property-details_wrap">
                <div className="property-info">
                  <p>Title</p>
                  <p>{propDetails[0]?.title}</p>
                  <p>Price</p>
                  <p>{propDetails[0]?.price}</p>
                  <p>Bedrooms</p>
                  <p>{propDetails[0]?.bedrooms}</p>
                  <p>Bath</p>
                  <p>{propDetails[0]?.bath}</p>
                  <p>Toilets</p>
                  <p>{propDetails[0]?.toilet}</p>
                  <p>Category</p>
                  <p>{propDetails[0]?.category}</p>
                  <p>Furnished</p>
                  <p>{propDetails[0]?.furnished ? "Furnished" : "Unfurnished"}</p>
                  <p>Serviced</p>
                  <p>{propDetails[0]?.serviced ? "Serviced" : "Unserviced"}</p>
                  <p>Shared</p>
                  <p>{propDetails[0]?.shared ? "Shared" : "Unshared"}</p>
                  <p>Square ft</p>
                  <p>{propDetails[0]?.square}sqft</p>
                  <p>Parking Space</p>
                  <p>{propDetails[0]?.parkingSpace ? "Available" : "Not available"}</p>
                  <p>Location</p>
                  <p>{propDetails[0]?.address}, {propDetails[0]?.lga}, {propDetails[0]?.state}</p>
                  <p>Description</p>
                  <p>{propDetails[0]?.description}</p>
                </div>

                <div>
                  {propDetails[0]?.images?.length !== 0 && 
                    <div className="property-images">
                     <Carousel>
                        {propDetails[0]?.images.map((item, index) => 
                          <div 
                            key={index} 
                            onClick={() => {
                              setPreviewModal(true);
                              setCurrentSlide(index + 1);
                            }}
                          >
                            <img src={`${baseUrl}/${item}`} alt={`Slide ${index}`} />
                          </div>
                        )}
                      </Carousel>
                    </div>
                  }
                  <div className="property-agent">
                    <h3>Agent details</h3>
                    <div className="property-agent_grid">
                      <p>Full name:</p>
                      <p>{propDetails[0]?.createdBy.firstname} {propDetails[0]?.createdBy.lastname}</p>
                      <p>Email:</p>
                      <p>{propDetails[0]?.createdBy.email}</p>
                      <p>Username:</p>
                      <p>@{propDetails[0]?.createdBy.username}</p>
                      <p>Phone No:</p>
                      <p>{propDetails[0]?.createdBy.phoneNumber}</p>
                      <p>Plan:</p>
                      <p>{propDetails[0]?.createdBy.subscriptionPlan}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <ImagePreviewModal 
            images={propDetails[0]?.images}
            previewModal={previewModal}
            setPreviewModal={setPreviewModal}
            currentSlide={currentSlide}
            setCurrentSlide={setCurrentSlide}
            baseUrl={baseUrl}
          />

        </section>
      </main>
    </div>
  )
}

export default AllProperties;